import styled from 'styled-components';

const IconsWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const IconCircle = styled.div`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: ${({ $bg }) => $bg};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: -5px;

  &:first-child {
    margin-left: -10px;
  }

  svg {
    width: 14px;
    height: 14px;
    fill: white;
  }
`;

const NoPermissions = styled.span`
  color: #9ca3af;
  font-size: 13px;
`;

const WhatsAppSvg = () => (
  <svg viewBox="0 0 24 24">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
  </svg>
);

const MessengerSvg = () => (
  <svg viewBox="0 0 24 24">
    <path d="M12 2C6.477 2 2 6.145 2 11.243c0 2.906 1.448 5.497 3.71 7.19v3.567l3.433-1.885c.916.254 1.885.39 2.857.39 5.523 0 10-4.145 10-9.262C22 6.145 17.523 2 12 2zm.996 12.474l-2.545-2.717-4.97 2.717 5.467-5.803 2.609 2.717 4.906-2.717-5.467 5.803z" />
  </svg>
);

// const FacebookSvg = () => (
//   <svg viewBox="0 0 24 24">
//     <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
//   </svg>
// );

const InstagramSvg = () => (
  <svg viewBox="0 0 24 24">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
  </svg>
);

// const GmailSvg = () => (
//   <svg viewBox="0 0 24 24">
//     <path d="M24 5.457v13.909c0 .904-.732 1.636-1.636 1.636h-3.819V11.73L12 16.64l-6.545-4.91v9.273H1.636A1.636 1.636 0 010 19.366V5.457c0-2.023 2.309-3.178 3.927-1.964L5.455 4.64 12 9.548l6.545-4.91 1.528-1.145C21.69 2.28 24 3.434 24 5.457z" />
//   </svg>
// );

const ImapSvg = () => (
  <svg viewBox="0 0 17 12">
    <path d="M15.5059 0H1.49414C0.671965 0 0 0.66901 0 1.49414V10.459C0 11.2844 0.672396 11.9531 1.49414 11.9531H15.5059C16.328 11.9531 17 11.2841 17 10.459V1.49414C17 0.668811 16.3277 0 15.5059 0ZM15.2764 0.996094C14.7934 1.48076 9.11907 7.17353 8.88595 7.40742C8.69125 7.60272 8.30885 7.60285 8.11405 7.40742L1.72357 0.996094H15.2764ZM0.996094 10.2759V1.67726L5.28146 5.97656L0.996094 10.2759ZM1.72357 10.957L5.98466 6.68206L7.40858 8.11063C7.99209 8.69603 9.00814 8.6958 9.59145 8.11063L11.0154 6.6821L15.2764 10.957H1.72357ZM16.0039 10.2759L11.7185 5.97656L16.0039 1.67726V10.2759Z" />
  </svg>
);

const PLATFORM_CONFIG = {
  whatsapp: {
    name: 'WhatsApp',
    icon: WhatsAppSvg,
    bg: 'linear-gradient(230.53deg, #47F868 19.61%, #16DC3F 92.94%)',
  },
  facebook: {
    name: 'Messenger',
    icon: MessengerSvg,
    bg: '#2D6CDF',
  },
  instagram: {
    name: 'Instagram',
    icon: InstagramSvg,
    bg: 'linear-gradient(230.53deg, #7951BB 19.61%, #D93182 55.57%, #FDB756 92.94%)',
  },
  // gmail: {
  //   name: 'Gmail',
  //   icon: GmailSvg,
  //   bg: '#EA4335',
  // },
  imap: {
    name: 'IMAP',
    icon: ImapSvg,
    bg: '#0277FF',
  },
};

const PlatformIcons = ({ platforms = [] }) => {
  if (!platforms || platforms.length === 0) {
    return <NoPermissions>-</NoPermissions>;
  }

  return (
    <IconsWrapper>
      {platforms.map((platform) => {
        const config = PLATFORM_CONFIG[platform];
        if (!config) return null;

        const IconComponent = config.icon;

        return (
          <IconCircle key={platform} $bg={config.bg} title={config.name}>
            <IconComponent />
          </IconCircle>
        );
      })}
    </IconsWrapper>
  );
};

export default PlatformIcons;
